import './IconLabel.scss';
import { ReactElement } from 'react';
import cn from 'classnames';

interface IconLabelProps {
  icon: ReactElement;
  label: string;
  className?: string;
  // Styling hook for the label text itself (separate from the root `className`).
  labelClassName?: string;
}

export const IconLabel = ({ icon, label, className, labelClassName }: IconLabelProps) => (
  <span className={cn('onboarding-icon-label', className)}>
    {icon}
    <span className={labelClassName}>{label}</span>
  </span>
);
